var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c(
    "div",
    { attrs: { id: "app" } },
    [
      _c("router-view"),
      _c(
        "Popup",
        _vm._b(
          {
            attrs: {
              animation: "fade",
              transparentBg: false,
              fullsize: false,
              hasBg: false,
              borderRadiusBySide: ["16px", "0", "0", "16px"],
              active: _vm.errorHandler.showPopup,
              size: "PopupSize.small",
              overlayClickable: false,
            },
            on: { close: _vm.handleClosePopup },
            scopedSlots: _vm._u([
              {
                key: "errorMsg",
                fn: function () {
                  return [
                    _c("div", { staticClass: "errorText" }, [
                      _c("p", [
                        _vm._v(_vm._s(_vm.$t(_vm.errorHandler.errorMessage))),
                      ]),
                      _c(
                        "a",
                        {
                          staticClass: "touched clickable",
                          on: {
                            click: function ($event) {
                              $event.stopPropagation()
                              return _vm.handleClosePopup.apply(null, arguments)
                            },
                          },
                        },
                        [_vm._v(_vm._s(_vm.$t("Okey, got it.")))]
                      ),
                    ]),
                  ]
                },
                proxy: true,
              },
            ]),
          },
          "Popup",
          {
            modalContainerStyles: _vm.defaultContainerStyle,
          },
          false
        )
      ),
      _c("Transition", [
        _vm.showBackDrop
          ? _c("div", {
              staticClass: "video-backdrop",
              on: { click: _vm.updateAutoScale },
            })
          : _vm._e(),
      ]),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }